import { useMutation, useQueryClient } from "@tanstack/react-query";
import { showErrorAlert } from "../../utils/showErrorAlert";
import { showSuccessToast } from "../../utils/showToastAlert";

/**
 * @param {object} deps
 * @param {(url: string, options: any) => Promise<any>} deps.callApiWithWorker
 * @param {(path: string) => void} deps.navigate
 * @param {(key: string) => string} deps.t
 */
export function usePostDataService({ callApiWithWorker, t }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["createDataService"],
    mutationFn: async (payload) => {
      return callApiWithWorker(`/dataservices`, {
        method: "POST",
        body: payload,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["dataServices"] });

      showSuccessToast(t("createdSubMessage", "Creation successfully"), {
        title: t("createdMessage", "Política creada"),
      });
    },
    onError: (error) => {
      console.error("Error al crear la política:", error);
      showErrorAlert(error);
    },
  });
}
